import React, { useState } from 'react';
import API from "libs/api";
import { Modal, Button } from 'semantic-ui-react';
import ICON from "components/cmp_icon/cmp_icon";



export default function CMP_NOTE_DELETE({ id, onOpen, onClose, onClose_update, onRefresh }) {

    //  variable declarations ------------------------------------------------------------------------------------------

    const [ var_processing, set_processing ] = useState('inactive');



    //  event listeners ------------------------------------------------------------------------------------------------



    //  async functions ------------------------------------------------------------------------------------------------

    async function delete_note() {

        set_processing('processing');

        try {
            await API_delete_note();
            set_processing('inactive');
            onRefresh();
            onClose_update();
            onClose();
        } catch (e) {
            set_processing('error');
            console.log(e);
        }
    }



    //  API calls ------------------------------------------------------------------------------------------------------

    function API_delete_note(){
        return API.del('admin-providers', '/delete-provider-note/' + id);
    }



    //  event functions ------------------------------------------------------------------------------------------------

    function onClick_delete(){
        delete_note();
    }

    function onClick_cancel(){
        onClose();
    }



    // RENDER APP ======================================================================================================

    return (
        <Modal
            dimmer={'inverted'}
            onClose={onClose}
            open={onOpen}
            closeOnEscape={true}
            closeOnDimmerClick={true}
            id='cmp_contact_delete'>

            <div className='icon__wrapper'>
                <div className='icon'>
                    <ICON name='warning' className='icon color--red-500' alt='contact icon'/>
                </div>
            </div>

            <div className="modal__header background--red--500">
                <div className='text--md bold color--white'>Delete note</div>
            </div>

            <div className='modal__content'>
                <div className='field__wrapper'>
                    <div className='text--base'>Are you sure you want to delete this note?</div>
                </div>
            </div>

            <div className='modal__footer'>
                <Button className='primary warning' onClick={onClick_delete}>Delete</Button>
                <Button className='secondary' onClick={onClick_cancel}>Cancel</Button>
            </div>
        </Modal>
    );
}